import { render, staticRenderFns } from "./SuppList.vue?vue&type=template&id=561113ec&scoped=true&"
import script from "./SuppList.vue?vue&type=script&lang=js&"
export * from "./SuppList.vue?vue&type=script&lang=js&"
import style0 from "./SuppList.vue?vue&type=style&index=0&id=561113ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561113ec",
  null
  
)

export default component.exports